import { deserialize } from 'cerialize'

export class ProductOrderStatusModel {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public external_name?: string
	@deserialize public is_deleted?: boolean
	@deserialize public merchant_status_code?: string
	@deserialize public source?: string
	@deserialize public source_id?: number
	@deserialize public sub_status_external_name?: string
	@deserialize public sub_status_name?: string
	@deserialize public send_sbercrm_status: boolean
	@deserialize public sbercrm_status?: string
	@deserialize public slug?: string

	public constructor(obj) {
		if (!obj) return
		if (obj.id) this.id = obj.id
		if (obj.name !== undefined && obj.name !== null) this.name = obj.name
		if (obj.external_name !== undefined && obj.external_name !== null)
			this.external_name = obj.external_name
		if (obj.is_deleted !== undefined && obj.is_deleted !== null) this.is_deleted = obj.is_deleted
		if (obj.merchant_status_code !== undefined && obj.merchant_status_code !== null)
			this.merchant_status_code = obj.merchant_status_code
		if (obj.source !== undefined && obj.source !== null) this.source = obj.source
		if (obj.source_id !== undefined && obj.source_id !== null) this.source_id = obj.source_id
		if (obj.sub_status_external_name !== undefined && obj.sub_status_external_name !== null)
			this.sub_status_external_name = obj.sub_status_external_name
		if (obj.sub_status_name !== undefined && obj.sub_status_name !== null)
			this.sub_status_name = obj.sub_status_name
		if (obj.sbercrm_status !== undefined && obj.sbercrm_status !== null)
			this.sbercrm_status = obj.sbercrm_status
		if (obj.slug !== undefined && obj.slug !== null) this.slug = obj.slug
	}
}
